import { useContext } from 'react'
import SessionContext from '../context/SessionContext'

export const useAppContext = () => {
  const context = useContext(SessionContext)

  if (!context) {
    throw new Error('useAppContext debe ser usado dentro de un SessionProvider')
  }

  return context
} 